import React, { useEffect, useState } from 'react';

const SecurityWrapper = ({ children }) => {
  const [securityStatus, setSecurityStatus] = useState({
    isSecure: true,
    warnings: [],
  });

  useEffect(() => {
    // Check for security issues
    const checkSecurity = () => {
      const warnings = [];

      // Check if running on HTTPS
      if (
        window.location.protocol !== 'https:' &&
        process.env.NODE_ENV === 'production'
      ) {
        warnings.push('Site should use HTTPS in production');
      }

      // Check for development tools
      if (process.env.NODE_ENV === 'development') {
        warnings.push('Development mode detected');
      }

      // Check for insecure content
      if (document.querySelector('script[src^="http:"]')) {
        warnings.push('Insecure scripts detected');
      }

      setSecurityStatus({
        isSecure: warnings.length === 0,
        warnings,
      });
    };

    checkSecurity();
  }, []);

  return (
    <div>
      {children}
      {process.env.NODE_ENV === 'development' &&
        securityStatus.warnings.length > 0 && (
          <div
            style={{
              position: 'fixed',
              bottom: '10px',
              right: '10px',
              background: 'rgba(255, 0, 0, 0.8)',
              color: 'white',
              padding: '10px',
              borderRadius: '5px',
              fontSize: '12px',
              zIndex: 9999,
            }}
          >
            Security Warnings: {securityStatus.warnings.join(', ')}
          </div>
        )}
    </div>
  );
};

export default SecurityWrapper;
